/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChecklistArray } from '../models/ChecklistArray'
import type { ChecklistResult } from '../models/ChecklistResult'
import type { CustomerConfirmation } from '../models/CustomerConfirmation'
import type { ProjectNote } from '../models/ProjectNote'
import type { ProjectVideoRequest } from '../models/ProjectVideoRequest'
import type { ProjectVideoResponse } from '../models/ProjectVideoResponse'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class DocumentationService {
  /**
   * 📱 Get all checklists
   * @returns any OK
   * @throws ApiError
   */
  public static getChecklists(): CancelablePromise<{
    data?: ChecklistArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/checklists',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Store a checklist.
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeChecklist(
    requestBody?: ChecklistResult,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/checklists',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Store a customer confirmation.
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeConfirmation(
    requestBody?: CustomerConfirmation,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/confirmations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Store a project note.
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeProjectNote(
    requestBody?: ProjectNote,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/projectnotes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Store project video metadata and get S3 upload URL.
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeProjectVideo(
    requestBody?: ProjectVideoRequest,
  ): CancelablePromise<{
    data?: ProjectVideoResponse
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/project-videos',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Mark video upload as completed and create Projectfile.
   * @param projectVideoId ID of the project video
   * @returns any OK
   * @throws ApiError
   */
  public static uploadCompleted(projectVideoId: number): CancelablePromise<{
    data?: {
      message?: string
    }
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/project-videos/{projectVideoId}/upload-completed',
      path: {
        projectVideoId: projectVideoId,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        404: `Project video not found or already completed`,
        409: `Upload already marked as completed`,
      },
    })
  }
  /**
   * 📱 Reinitialize upload for existing video (if not completed).
   * @param projectVideoId ID of the project video
   * @returns any OK
   * @throws ApiError
   */
  public static reinitializeUpload(projectVideoId: number): CancelablePromise<{
    data?: ProjectVideoResponse
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/project-videos/{projectVideoId}/reinitialize-upload',
      path: {
        projectVideoId: projectVideoId,
      },
      errors: {
        401: `The request was unauthenticated`,
        404: `Project video not found or already completed`,
      },
    })
  }
}
